import React from "react";
import ChatMessage from "./ChatMessage";
import '../../../assets/sass/components/messages/chat/chat-receive.scss';

class ChatReceive extends ChatMessage {

    messageHtml = () => {
        var {data} = this.props;

        return (
            <div className="chat-receive">
                <img className="chat-avatar" src={data.avatar} alt={data.name}/>
                <div className="receive-content">
                    {this.appendContent(data)}
                    <time className="date">{ data.date ?? "Today 12:30 pm"}</time>
                </div>
            </div>
        )
    }
};

export default ChatReceive;